// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"833":"bdf48f8b","887":"64646968"}[chunkId] + ".chunk.css";
};